<template>
<div>
    <Breadcrumbs main="Finance & Accounts" submain="Accounts" title="Labels" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Create Label</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-wrap" style="gap: 20px;">
                                    <b-input-group class="datatable-btn" style="width: 340px;">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    </b-input-group>

                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!accountLabelsLoading && !accountLabelsError">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(balance_sheet)="data">
                                        {{ data.item.balance_sheet !== null ? data.item.balance_sheet.title : "N/A" }}
                                    </template>

                                    <template #cell(title)="data">
                                        <router-link :to="{ path: '/finance-and-accounts/account/label-details/' + data.item.id }">
                                            {{ data.item.title }}
                                        </router-link>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteItem(data.item.id)" title="Delete"></feather>
                                            <feather @click="editLabel(data.item)" type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Create Ledger -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Create Label" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">

            <b-form-group label="Title" label-for="name-input" invalid-feedback="Title is required">
                <b-form-input id="name-input" v-model="label.title" placeholder="Enter title"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Edit Ledger -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Label" @show="resetModal" @hidden="resetModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">

            <b-form-group label="Title" label-for="name-input" invalid-feedback="Title is required">
                <b-form-input id="name-input" v-model="edit_label.title" placeholder="Enter title"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>

    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this item?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    data() {
        return {
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            items: [],
            label: {
                title: "",
                balance_sheet: ""
            },

            edit_label: {
                id: "",
                title: ""

            },
            delete_value: "",
            options: [],


            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState('account', ["accountLabelsPG", "accountLabels_count", "accountLabelsLoading", "accountLabelsError", "submitError", "submitSuccess", "submitLoading"]),

    },

    created() {
        this.$store.dispatch('account/fetchTransactionLabel')
    },

    watch: {
      accountLabelsPG(oldValue, newValue) {
            this.items = this.accountLabelsPG
            this.totalRows = this.accountLabels_count;
        },

        currentPage(newCurrentPage) {
            this.$router.replace({
                path: '/finance-and-accounts/account/labels',
                query: {
                    page: newCurrentPage,
                    perPage: this.perPage
                }
            });
            this.currentPage = newCurrentPage
            this.$store.dispatch("account/fetchTransactionLabelWithPagination", {
                perPage: this.perPage,
                currentPage: newCurrentPage,
                search_term: this.filter,

            }).then(() => {
                this.totalRows = this.accountLabels_count;
            });
        },

        perPage(newperPage) {
            this.$router.replace({
                path: '/finance-and-accounts/account/labels',
                query: {
                    page: this.currentPage,
                    perPage: newperPage
                }
            });
            this.perPage = newperPage
            this.$store.dispatch("account/fetchTransactionLabelWithPagination", {
                perPage: newperPage,
                currentPage: this.currentPage,
                search_term: this.filter,
            }).then(() => {
                this.totalRows = this.accountNotes_count;
            });
        },


    },

    mounted() {
        if (!this.$route.query.page || !this.$route.query.perPage) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    page: this.currentPage,
                    perPage: this.perPage
                }
            });
            this.$store.dispatch("account/fetchTransactionLabelWithPagination", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,
            }).then(() => {
                this.totalRows = this.accountLabels_count;
            });
        } else {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    page: this.$route.query.page,
                    perPage: this.$route.query.perPage
                }
            });
            this.currentPage = this.$route.query.page
            this.perPage = this.$route.query.perPage

            this.$store.dispatch("account/fetchTransactionLabelWithPagination", {
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                search_term: this.filter,
            }).then(() => {
                this.totalRows = this.accountLabels_count;
            });
        }
    },

    methods: {
        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },



        resetModal() {
            this.label.title = ''
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleSubmit() {

            this.label.perPage=this.perPage
            this.label.currentPage=this.currentPage
            this.label.search_term=this.filter

            this.$store.dispatch("account/addTransactionLabel", this.label).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.label.title = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editLabel(item) {
            console.log(item)
            this.edit_label.id = item.id
            this.edit_label.title = item.title

        },

        // resetEditModal() {
        //     this.edit_item.name = ""
        //     this.edit_item.id = null
        //     this.edit_item.rate = null
        //     this.edit_item.description = ""
        // },

        handleEditSubmit() {
          this.edit_label.perPage=this.perPage
          this.edit_label.currentPage=this.currentPage
          this.edit_label.search_term=this.filter

          this.$store.dispatch("account/updateTransactionLabel", this.edit_label).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.edit_label.id = ""
                    this.edit_label.title = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteItem(id) {
          console.log(id)
            this.delete_value = id
        },

        handleDeleteOk() {
          let payload= {}
          payload.perPage=this.perPage
          payload.currentPage=this.currentPage
          payload.search_term=this.filter
          payload.id=this.delete_value

          this.$store.dispatch("account/deleteTransactionLabel", payload).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
